import {useEffect, useState } from 'react';
import $ from "jquery";
import { properties } from '../../properties';
import LoaderComp from '../LoaderComp';
import transidgenerator from '../../transidgenerator';
import { getBasketCustomVars } from './BasketCustomVars';

function Tokenise({apiUrl}) {
    const [tokenise, setTokenise] = useState({
        operation: properties.OPERATIONS.tokenise,
        password:properties.PASSWORD,
        timestamp: "",
        vendorid: properties.VENDOR_ID,
        transactionid: transidgenerator(),
        method: properties.HTTP_METHOD,
        description:properties.DESCRIPTION,
        region: properties.SEL_REGION,
        address: properties.ADDRESS,
        postCode: properties.POST_CODE,
        countryCode: properties.COUNTRY_CODE,
        allowAvsFail: properties.ALLOW_AVS_FAIL,
        customerId: properties.CUSTOMER_ID,
        security:""
    });
    
    const [isDpaFlag, setIsDpaFlag] = useState("false");

    var region =[];

    for(var property in properties.REGIONS){
        region.push(<option value={property} key={property}>{properties.REGIONS[property]}</option>);
    }

    var canSubmit = true;
    
    function isNotNullCheck(e, field){
        if(e === "" || !e){
            document.getElementsByName(field)[0].classList.add("emptied");
            document.getElementsByName(field)[1].classList.add("emptied");
            canSubmit = false;
        }
        else{
            document.getElementsByName(field)[0].classList.remove("emptied");
            document.getElementsByName(field)[1].classList.remove("emptied");
        }
    }

    function changeTransId(e) {
        isNotNullCheck(e.target.value,"WPG_transID");
        setTokenise({ ...tokenise, transactionid: e.target.value });
    }

    function changeVendorId(e) {
        isNotNullCheck(e.target.value,"WPG_vendorID");
        setTokenise({ ...tokenise, vendorid: e.target.value });
    }

    function changePwd(e) {
        isNotNullCheck(e.target.value,"vendorPwd");
        setTokenise({ ...tokenise, password: e.target.value });
    }

    function changeDesc(e) {
        setTokenise({ ...tokenise, description: e.target.value });
    }

    function changeAddr(e) {
        setTokenise({ ...tokenise, address: e.target.value });
    }

    function changePostCode(e) {
        setTokenise({ ...tokenise, postCode: e.target.value });
    }

    function changeCountryCode(e) {
        setTokenise({ ...tokenise, countryCode: e.target.value });
    }

    function changeRegion(e) {
        isNotNullCheck(e.target.value,"WPG_region");
        setTokenise({ ...tokenise, region: e.target.value });
    }

    function changeAllowAvsFail(e) {
        setTokenise({ ...tokenise, allowAvsFail: e.target.value });
    }

    function changeCustomerId(e) {
        setTokenise({ ...tokenise, customerId: e.target.value });
    }

    function changeDpaFlag(e) {
        setIsDpaFlag(e.target.value);
    }

    useEffect(() => {
        $(".page-body").scrollTop(0);
    },[]);    

    function submitTokenise(e) {
        e.preventDefault();
        isNotNullCheck(tokenise.password,"vendorPwd");
        isNotNullCheck(tokenise.vendorid,"WPG_vendorID");
        isNotNullCheck(tokenise.transactionid,"WPG_transID");
        isNotNullCheck(tokenise.region,"WPG_region");
        if(canSubmit){
            document.getElementsByClassName("loader")[0].classList.add("loading");
            if(tokenise.region === "NoR"){
                setTokenise({...tokenise, region:""});
            }
            $("#pwd").remove();
            var md5 = require('md5');
            var time = Math.floor(Date.now() / 1000);
            $("#tokenise_timestamp").val(time);
            var digest=md5(time + tokenise.vendorid + tokenise.transactionid + tokenise.method +
                tokenise.description + tokenise.region + tokenise.address + tokenise.postCode +
                tokenise.countryCode + tokenise.allowAvsFail + tokenise.password);
            $("#tokenise_security").val(digest);
            $("#tokeniseForm").attr('action', apiUrl).submit();
        }
    }

    var tokeniseTemplate = (
        <div className="operation-form">
            <h2>Tokenise</h2>
            <form className="form-horizontal" id="tokeniseForm" onSubmit={submitTokenise} method='POST'>
                <input type="hidden" name="WPG_CUSTOM_Operation" value={tokenise.operation} />
                <input type="hidden" name="WPG_operation" value={tokenise.operation} />
                <input type="hidden" name="WPG_method" value={tokenise.method}/>
                <div className="form-group">
                    <div className="control-label">
                        Dpa Flag
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_dpaFlag" value={isDpaFlag} onChange={changeDpaFlag}>
                            <option value="true">Yes</option>
                            <option value="false">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Transaction ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                            <input type="text" className="form-control" name="WPG_transID" value={tokenise.transactionid} onChange={changeTransId} />
                            <div className="error-msg" name="WPG_transID">Transaction ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                    Client Application ID<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                            <input type="text" className="form-control" name="WPG_vendorID" value={tokenise.vendorid} onChange={changeVendorId} />
                            <div className="error-msg" name="WPG_vendorID">Client Application ID is mandatory</div>
                    </div>
                </div>
                <div className="form-group" id="pwd">
                    <div className="control-label">
                        Client Application Password<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <input type="password" className="form-control" name="vendorPwd" value={tokenise.password} onChange={changePwd} />
                        <div className="error-msg" name="vendorPwd">Client Application Password is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Description
                    </div>
                    <div className="col-sm-5">
                            <input type="text" className="form-control" name="WPG_description" value={tokenise.description} onChange={changeDesc} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Region<span className="mandatory-indicator">*</span>
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_region" onChange={changeRegion} value={tokenise.region}>
                            {region}
                        </select>
                        <div className="error-msg" name="WPG_region">Region is mandatory</div>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Address
                    </div>
                    <div className="col-sm-5">
                            <input type="text" className="form-control" name="WPG_address" value={tokenise.address} onChange={changeAddr} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Postal/Zip Code
                    </div>
                    <div className="col-sm-5">
                            <input type="text" className="form-control" name="WPG_postcode" value={tokenise.postCode} onChange={changePostCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        ISO Country Code
                    </div>
                    <div className="col-sm-5">
                            <input type="text" className="form-control" name="WPG_countryCode" value={tokenise.countryCode} onChange={changeCountryCode} />
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Allow AVS Fail
                    </div>
                    <div className="col-sm-5">
                        <select className="form-control" name="WPG_allowAVSFail" onChange={changeAllowAvsFail} value={tokenise.allowAvsFail}>
                            <option value="Y">Yes</option>
                            <option value="N">No</option>
                        </select>
                    </div>
                </div>
                <div className="form-group">
                    <div className="control-label">
                        Customer Id
                    </div>
                    <div className="col-sm-5">
                        <input type="text" className="form-control" name="WPG_customerId" value={tokenise.customerId} onChange={changeCustomerId} />
                    </div>
                </div>
                <input type="hidden" name="WPG_timestamp" id="tokenise_timestamp" value="" />
                <input type="hidden" name="WPG_security" id="tokenise_security" value="" />
                {getBasketCustomVars()}
                <div className="form-group">
                    <div className="col-sm-5">
                        <button type="submit" className="btn btn-primary" >Continue</button>
                    </div>
                </div>
            </form>
            <div className="loader-div">
                <span className="loader"><LoaderComp/></span>
            </div>
        </div>
    );

    return tokeniseTemplate;
}

export default Tokenise;